import React from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MiniSpinner from "../common/MiniSpinner";

class VideoVisitDetails extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.getVideoVisitConditions();
        logUI("MBHWeb.UI.VideoVisitDetails.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    linkMyInsurance = () => {
        this.props.history.push({
            pathname: '/linkedaccounts',
            searchParams: "openInsurance=true"
        });
    }
    render() {
        const { price, aalDown, hasAAL, serverData, currentUser, isProxyUser, technicalHelpDeskNumber, technicalHelpDeskHours, myChartRegistrationUrl, hasHealthPlan, isWaiting, isActiveFeature_SDCVideoVisit, hasAuthorizedFeatureSameDayVideo } = this.props;
        let markup = "";     
        let eligibleToScheduleVideoVisit = false;
        const insurancePlan = "Baylor Scott & White Health Plan or DFW Connected Care";
        const insuranceText = hasAAL ? "DFW ConnectedCare copay" : hasHealthPlan ? "$0 copay for most plans. High deductible plans covered at 100% after meeting deductible." : "";
        const insuranceClass = insuranceText === "" ? "d-flex align-items-center" : "";
        const { conditions } = this.props.videoVisitConditions;
        const videoVisitConditions = conditions && conditions.treatableConditions && conditions.treatableConditions.length > 0 ? conditions.treatableConditions : [];
        const videoVisitConditionsSplit = videoVisitConditions ? ((videoVisitConditions.length / 2) + 1) : 0;
        const displayName = currentUser && currentUser.firstName ? currentUser.firstName : currentUser ? getFirstName(currentUser.displayName) : "";
        const minimumAge = 18;
        const showDisplayName = isProxyUser ? ("(" + displayName + ")") : "";
        if (isProxyUser && currentUser) { //user is mychart proxy, so take age and show the appropriate message. 
            const isMinor = currentUser && currentUser.ageYears && currentUser.ageYears >= 0 && currentUser.ageYears < minimumAge;
            if (isMinor) {
                markup = (<div className="col-12">
                    <label>
                        {displayName} cannot take a Video On Demand within MyBSWHealth. They must be at least {minimumAge} years old.
                    </label>
                </div>);
            } else { // if age is unknown for mychart proxies.
                markup = <div className="col-12">
                    <label>
                        {displayName} must schedule Video On Demand from their own MyBSWHealth account. They must be at least {minimumAge} years old and have either Baylor Scott & White Health Plan or DFW ConnectedCare insurance linked to their account.
                     If they do not have an account, they can create one <Link to={{ pathname: myChartRegistrationUrl }} target="_blank">here</Link>.<br /><br />
                        For technical assistance, please call the MyBSWHealth Technical Help Desk {technicalHelpDeskHours} at{' '} <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                    </label>
                </div>;
            }
        } else if (!isActiveFeature_SDCVideoVisit && hasAuthorizedFeatureSameDayVideo) {
            markup = (<div className="col-12">
                <label>
                    You must have {insurancePlan} insurance linked to your account in order to schedule a Video On Demand. <button className='btn text-btn' onClick={this.linkMyInsurance}>Link my insurance</button>
                </label>
            </div>);
        }
        else
            eligibleToScheduleVideoVisit = true;
        
        return (
            <div className="container-fluid body-content">
                {eligibleToScheduleVideoVisit ?                    
                        <div className="row video-visit-details-container">
                            <div className="col-12">

                                <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        <h1 className="page-heading">Video On Demand</h1>
                                        <div className="page-subheading">Schedule a Video On Demand at a time that's convenient for you!</div>
                                    </div>
                                </div>

                                <div className="row video-visit-steps">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12 col-md-3 video-visit-steps__group">
                                                <div className="svg-interview" />
                                                <h4>No Waiting Around</h4>
                                            </div>
                                            <div className="col-12 col-md-4 video-visit-steps__group">
                                                <div className="svg-find-a-doc" />
                                                <h4>Diagnosis by a BSWH Provider</h4>
                                            </div>
                                            <div className="col-12 col-md-5 video-visit-steps__group">
                                                <div className="svg-prescription" />
                                                <h4>Response & Prescription (if needed) in 1hr</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row video-visit-cost-est">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className={"col-12 col-md-6 col-xl-3 " + insuranceClass}>
                                                <div className="d-flex align-items-center">
                                                    <span>{(hasAAL || hasHealthPlan) && price <= 75 ? 'Your Estimated Cost' : 'Your Max Cost'}: </span>
                                                    <span>&nbsp;$</span><span className="video-visit-cost-est__price">{price}</span>
                                                </div>
                                                <div className="connected-care-text">{insuranceText}</div>
                                            </div>
                                            <div className="col-12 col-md-6 col-xl-9 d-flex align-items-center">
                                            <Link className="btn btn-primary" to={{ pathname: "/schedulevideovisit" }}>Get Started</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {serverData && serverData.enableAA && hasAAL && !aalDown &&
                                    <div className="row video-visit-travel">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12 col-md-6 col-xl-3 d-flex align-items-center video-visit-travel__heading"><span className="traveling-text">Traveling outside Texas?</span></div>
                                                <div className="col-12 col-md-6 col-xl-9 d-flex align-items-center"><Link className="icontextlink mobile-wrapped-link" to={{ pathname: "/evisittravel" }} >SEE MORE OPTIONS <span className="icon-arrow-sm-rt" /></Link></div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="row video-visit-symptoms">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12"><h4>Symptoms we treat:</h4></div>
                                            {!isWaiting ?
                                                <>
                                                    {videoVisitConditions && videoVisitConditions.length > 0 &&
                                                        <React.Fragment>
                                                            <div className="col-12 col-md-6 col-xl-3">
                                                                <ul className="angle-bullets">
                                                                {videoVisitConditions.slice(0, videoVisitConditionsSplit).map((condition, index) => {
                                                                    return (
                                                                        <li key={index}>{condition.conditionName}</li>
                                                                    );
                                                                })}
                                                                </ul>
                                                            </div>
                                                            <div className="col-12 col-md-6 col-xl-9">
                                                                <ul className="angle-bullets">
                                                                    {videoVisitConditions.slice(videoVisitConditionsSplit, videoVisitConditions.length).map((condition, index) => {
                                                                        return (
                                                                            <li key={index}>{condition.conditionName}</li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </React.Fragment>
                                                    }
                                                </>
                                                : <div className="col-12 align-self-center">
                                                    <MiniSpinner />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    : (<div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="page-heading">Video On Demand {showDisplayName}</h1>
                                </div>
                                {markup}
                            </div>
                        </div>
                    </div>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    let priceValue = '75';
    return {
        price: priceValue,
        hasAAL: state.memberships.hasAA,
        aalDown: state.common.aalDown,
        serverData: state.session.serverData,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        isProxyUser: state.domain.ip,
        myChartRegistrationUrl: state.session.serverData && state.session.serverData.myChartRegistrationUrl,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        hasHealthPlan: state.memberships.hasAnySWHP,
        videoVisitConditions: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions : {},
        isWaiting: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions.isWaiting : false,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        hasAuthorizedFeatureSameDayVideo: state.memberships.hasAuthorizedFeatureSameDayVideo
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitConditions: () => dispatch({ type: types.GET_VIDEO_VISIT_CONDITIONS }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoVisitDetails);